import { render, staticRenderFns } from "./SettingOneView.vue?vue&type=template&id=595411d6&scoped=true"
import script from "./SettingOneView.vue?vue&type=script&lang=js"
export * from "./SettingOneView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595411d6",
  null
  
)

export default component.exports